import * as Yup from 'yup';
import { FlatOrganisationsNavQuery, UpsertWorkspaceMutationVariables } from 'src/graphql/_generated';

export type WorkspaceFormValues = Omit<UpsertWorkspaceMutationVariables, 'workspaceId' | 'notificationScheduleTime'>;

type FlatOrganisation = FlatOrganisationsNavQuery['flatOrganisations'][number];

export const createWorkspaceValidationSchema = (flatOrganisations: FlatOrganisation[] = []) =>
  Yup.object({
    name: Yup.string()
      .required('Required')
      .max(200, 'Max 200 characters')
      .test('unique-name', 'Workspace name already exists', function (value) {
        if (!value) return true;
        const { organisationId } = this.parent;
        if (!organisationId) return true;

        const existingWorkspaceNames = flatOrganisations
          .filter((o) => o.recordType === 'W' && o.parentId === organisationId)
          .map((o) => o.name.trim().toLowerCase());

        return !existingWorkspaceNames.includes(value.trim().toLowerCase());
      }),
    primaryContact: Yup.string().required('Required').email('Invalid email address').max(100, 'Max 100 characters'),
    organisationId: Yup.string().required('Required'),
    plan: Yup.string().required('Required'),
    isRestricted: Yup.boolean().required('Required'),
    currency: Yup.string()
      .max(3, 'Currency must be at most 3 characters long')
      .matches(/^[^\s]*$/, 'Currency must not contain spaces')
      .nullable(),
  });

export const workspaceValidationSchema = createWorkspaceValidationSchema([]);

export const workspaceInitialValues: WorkspaceFormValues = {
  name: '',
  primaryContact: '',
  organisationId: '',
  plan: '',
  isRestricted: true,
  currency: undefined,
};
